import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  onClick?: () => void;
}

const paddingStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-4 sm:p-5',
  lg: 'p-6 sm:p-8',
};

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  hover = false,
  onClick,
}) => {
  return (
    <div
      className={`
        bg-white/60 dark:bg-[#1a1a2e]/80 backdrop-blur-lg rounded-2xl border border-white/50 dark:border-indigo-500/10
        shadow-soft
        ${paddingStyles[padding]}
        ${hover
          ? 'hover:-translate-y-1 hover:shadow-card-hover hover:border-primary-100 dark:hover:border-indigo-500/20 transition-all duration-300 cursor-pointer'
          : 'transition-all duration-200'
        }
        ${className}
      `.trim()}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => (
  <div className={`flex items-center justify-between mb-4 ${className}`}>
    {children}
  </div>
);

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children, className = '' }) => (
  <h3 className={`text-lg font-semibold text-neutral-800 dark:text-neutral-100 ${className}`}>
    {children}
  </h3>
);
